import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../../data/constants';
import { getLocators } from '../../api/production-request-api/index.js';
import { useApiReady } from '@pella/fetch-client-react';

/**
 * Hook to fetch locators by plant and subinventory.
 * @param {Local.GetLocatorsInput} input - The input parameters to retrieve the locators.
 */
export const useLocators = (input) => {
  const { apiReady } = useApiReady();

  return useQuery({
    queryKey: [QUERY_KEYS.LOCATORS, input],
    queryFn: () => getLocators(input),
    enabled: Boolean(apiReady && input?.organizationId && input?.subinventoryCode && input?.inventoryItemId),
  });
};
